import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon, { SHAPES } from './Icon';
import IconLibrary from './IconLibrary';
import IconButton from './IconButton';
import IconPicker from './IconPicker';
import classifierValues from '../static/classifier.json';
export { IconPicker, IconButton, IconLibrary, SHAPES, classifierValues };
export default Icon;